<template>
    <div class="menu_block">
        <div class="menu_list">
            <div class="menu">
                <ul>
                    <navigation-menu-item
                        v-for="(item, index) in navigationItems"
                        :key="index"
                        :item="item"
                    />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import NavigationMenuItem from '@/components/articles/NavigationMenuItem.vue';

export default {
    components: {
        NavigationMenuItem
    },

    props: {
        navigationItems: {
            type: Array,
            required: true
        }
    }
};
</script>
